import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.672 18.49c0 .168-.122.373-.273.458L9.11 21.937a.623.623 0 0 1-.548 0l-5.288-2.99A.58.58 0 0 1 3 18.49v-5.978c0-.17.123-.374.274-.458l5.288-2.99a.623.623 0 0 1 .548 0l5.289 2.99a.58.58 0 0 1 .273.458v5.978zm29.361-5.55H39.3v1.108H41v4.73h1.34v-4.73h1.694V12.94zm-21.507 0h-4.74v1.108h1.7v4.73h1.34v-4.73h1.7V12.94zm13.704-.182c-1.491 0-2.32.93-2.32 2.277v3.743h1.326v-3.771c0-.585.353-1.037 1.008-1.037.656 0 1.002.536 1.002 1.037v3.771h1.325v-3.743c.008-1.347-.85-2.277-2.341-2.277zm-5 .183v5.837h1.325v-5.837H31.23zm-4.496 2.312.043.261 1.246 3.264h.54l1.694-5.837h-1.304l-.807 3.067-.05.331-.066-.331-1.08-3.067h-.433l-1.08 3.067-.065.331-.043-.331-.807-3.067H23.21l1.694 5.837h.54l1.246-3.264.043-.26",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m11.595 15.514-1.384 1.981-.706-1.057.814-1.192c.152-.211.476-.796.101-1.593-.303-.649-.958-.959-1.535-.959-.576 0-1.203.29-1.541.96a1.504 1.504 0 0 0 .093 1.571s.454.65.829 1.199l.612.867.923 1.382c.007.007.151.225.41.225.245 0 .397-.218.418-.24l2.162-3.13h-1.196V15.515zm-2.717.05s-.36-.536-.598-.91c-.252-.402.029-1.001.598-1.001.57 0 .85.6.599 1-.231.375-.599.91-.599.91z",
			fill: "url(#u7xqgwbswa)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.553 17.432 6.198 15.57s-.36-.536-.598-.91c-.252-.402.029-1 .598-1 .073 0 .137.006.202.027l.476-.853a1.707 1.707 0 0 0-2.212.818 1.504 1.504 0 0 0 .093 1.572l2.371 3.434c.022.028.173.246.425.246s.396-.211.418-.24l.714-1.064-.613-.881-.519.712z",
			fill: "url(#swq2zak5tb)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
			id: "u7xqgwbswa",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(6.37225 0 0 7.02845 8.429 13.238)",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FC0" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .092,
					stopColor: "#FFC800"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .174,
					stopColor: "#FFBD00"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .253,
					stopColor: "#FFAB00"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#FF9100"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .405,
					stopColor: "#FF7000"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .479,
					stopColor: "#FF4700"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .55,
					stopColor: "#FF1800"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .582,
					stopColor: "red"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "red"
				})
			]
		}), /* @__PURE__ */ _jsxs("radialGradient", {
			id: "swq2zak5tb",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(5.84297 0 0 8.64455 4.588 13.596)",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#00B4E6" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .201,
					stopColor: "#00B0E3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .39,
					stopColor: "#01A5DB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .574,
					stopColor: "#0292CD"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .755,
					stopColor: "#0377BA"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .932,
					stopColor: "#0455A1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#054696"
				})
			]
		})] })
	]
});
export default SvgTwint;
